import Salesboard from './Salesboard';

export default Salesboard;
